import SoundMeter from '../utils/soundmeter';

export default {
  data() {
    return {
      soundLevel: 0,
      audioError: false, // 调用声音设备时是否报错
      detecTimer: null,
    };
  },
  mounted() {

  },
  methods: {
    initDetector(stream) {
      if (this.detectTimer) { // clear timer anyway
        clearInterval(this.detectTimer);
        this.detectTimer = null;
      }
      let MyAudioContext;
      let myAudioContext;
      try {
        MyAudioContext = window.AudioContext || window.webkitAudioContext;
        myAudioContext = new MyAudioContext();
      } catch (e) {
        this.$message.error('Web Audio API not supported.');
      }
      const soundMeter = new SoundMeter(myAudioContext);
      soundMeter.connectToSource(stream, (e) => {
        if (e) {
          console.log(e);
          this.audioError = true;
        } else {
          this.detectTimer = setInterval(() => {
            const data = soundMeter.instant.toFixed(2);
            this.soundLevel = data > 1 ? 1 : data;
            // this.soundLevel = soundMeter.clip.toFixed(2);
            // this.soundLevel = soundMeter.slow.toFixed(2);

            // console.log(this.soundLevel);
          }, 200);
        }
      });
    },

  },
};
